import { Component } from '@angular/core';
import { IconType } from 'components/layout/icon/icon.component';
import { CredentialType } from 'enums/CredentialType';
import { MenuItem } from 'models/MenuItem';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { CurrencyPipe } from 'pipes/currency.pipe';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { CredentialRequired } from 'services/credential.service';
import { DateService } from 'services/date.service';
import { ComponentUrl } from 'services/navigation.service';

@Component({
	selector: 'debug-context-menu',
	templateUrl: './debug-context-menu.component.html',
	imports: [Layout, ListView, CurrencyPipe, CustomDatePipe]
})
@ComponentUrl('debug-context-menu')
@CredentialRequired(CredentialType.AccessDebugViews)
export class DebugContextMenuComponent {

	menuItems: MenuItem[] = [];

	rowDataList: { dateColumn: Date, currencyColumn: number, stringColumn: string }[];

	constructor(private readonly dateService: DateService) {

		this.menuItems = this.generateMenuItems(2, true, [CredentialType.CreateCreditMemo, CredentialType.AccessDebugViews], [{ icon: 'building' }, { icon: 'building' }, { icon: 'user' }]);

		this.rowDataList = this.generateListData(50);

	}

	generateListData(amount: number): { dateColumn: Date; currencyColumn: number; stringColumn: string; }[] {
		const rowDataList: { dateColumn: Date; currencyColumn: number; stringColumn: string; }[] = [];
		for (var i = 1; i <= amount; i++) {
			rowDataList.push({ dateColumn: this.dateService.addDays(new Date(), i), currencyColumn: i, stringColumn: `Row ${i}` });
		}
		return rowDataList;
	}

	private generateMenuItems(amount: number, useText: boolean, credentials: CredentialType[], icons: { icon: IconType }[]) {
		const menuItems: MenuItem[] = [];
		for (var i = 1; i <= amount; i++) {
			const credential = credentials.length > 0 ? credentials[i % credentials?.length] : undefined;
			const icon = icons.length > 0 ? icons[i % icons?.length] : undefined;
			menuItems.push(this.addMenuItem(i, useText, credential, icon));
		}
		return menuItems;
	}

	private addMenuItem(index: number, useText: boolean, credential?: CredentialType, icon?: { icon: IconType }) {
		return new MenuItem({
			text: useText ? `Menu ${index}` : '',
			credentials: credential ? [credential] : undefined,
			icon: icon ? icon.icon : undefined,
			action: () => { console.log(`Clicked menu ${index}`); }
		})
	}

	test(clickedText: string) { console.log(`Clicked menu ${clickedText}`); }

}
